import { IApplicationState, TCardId } from '../../../types/types';
import { getCardChecklists } from '../checklists/checklists/selectors/getCardChecklists';

export const getCardEpicChecklistsStartDate = (
    state: IApplicationState,
    cardId: TCardId,
): number => {
    const checklists = getCardChecklists(state, cardId);
    let checkListStartDate = Infinity;

    for (let checklist in checklists) {
        let checkitems = checklists[checklist].checkItems ? Object.values(checklists[checklist].checkItems) : null;
        if (checkitems && checkitems.length) {
            checkitems.forEach((item => {
                if (item && item.startDate && checkListStartDate > item.startDate) {
                    checkListStartDate = item.startDate
                }
            }))
        }
    }
    return checkListStartDate === Infinity ? null : checkListStartDate;
}
